import { render } from "./ContactModal.vue?vue&type=template&id=21c31b81&scoped=true&ts=true"
import script from "./ContactModal.ts?vue&type=script&lang=ts"
export * from "./ContactModal.ts?vue&type=script&lang=ts"

import "./ContactModal.scss?vue&type=style&index=0&id=21c31b81&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c31b81"]])

export default __exports__